import { render } from "./StartBackup.vue?vue&type=template&id=0a76b1a3&scoped=true"
import script from "./StartBackup.vue?vue&type=script&lang=js"
export * from "./StartBackup.vue?vue&type=script&lang=js"

import "./StartBackup.vue?vue&type=style&index=0&id=0a76b1a3&lang=scss&scoped=true"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.22.1.1/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a76b1a3"]])

export default __exports__